import { useQuery } from '@tanstack/react-query';
import { ApiException, LineGroupingDto } from 'src/api/FiretrolApiClient';
import { designModelApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const GROUPING_STALE_TIME = 60_000;

/**
 * @registry CAD/FAB line grouping for a design model. A 404 means the model has
 * no grouping yet (no CAD/FAB source, or still processing) and reads as null.
 */
export function useDesignModelGrouping(id: string | null | undefined) {
  return useQuery<LineGroupingDto | null>({
    queryKey: queryKeys.designModels.grouping(id ?? ''),
    queryFn: async ({ signal }) => {
      try {
        return await designModelApiClient.getGrouping(
          id!,
          toCancelToken(signal),
        );
      } catch (err) {
        if (ApiException.isApiException(err) && err.status === 404) return null;
        throw err;
      }
    },
    enabled: !!id,
    staleTime: GROUPING_STALE_TIME,
    meta: { errorContext: 'design model grouping' },
  });
}
